// Models
import { CampaignDesignation, DesignationsPageResponse } from 'models/Designation'

// Redux services
import { getCampaignDesignations } from 'redux/services/designation'

// Local
import { RootState, TypedDispatch } from 'redux/store'
import { FinalizeOrderArgs } from '../types'

/**
 * Updates the transaction with designation information.
 * @param cid - Campaign ID
 * @param transaction - Transaction details
 */
const getDesignationId = async (
  store: RootState,
  dispatch: TypedDispatch<RootState>,
  args: FinalizeOrderArgs,
): Promise<number | undefined> => {
  if (store.order.designation.value.designationId) {
    return store.order.designation.value.designationId
  }

  const designations: DesignationsPageResponse<CampaignDesignation> = await dispatch(
    getCampaignDesignations.initiate({
      campaignId: String(args.campaign.campaign_id),
      params: { filter: { is_default: true, is_active: true } },
    }),
  ).unwrap()

  if (designations.total > 0) {
    return designations.data[0].id
  }

  // Should always have a default designaiton, but just in case
  return undefined
}

export default getDesignationId
